var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarkerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFC89A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8769 13.2353C23.3595 12.9216 23.9868 12.9216 24.4694 13.2353L31.3463 16.7823V29.957H25.9413L22.5873 35V31.0669L24.7831 27.7612H29.1505V18.1094L23.6732 15.2863L18.1958 18.1094V27.7612H22.5632V29.957H16V16.7823L22.8769 13.2353Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerCircle);
export default __webpack_public_path__ + "static/media/map-marker-circle.b246ec6e0c6514e941a1de01d60d5b17.svg";
export { ForwardRef as ReactComponent };